module.exports = require('./helpers/bundle-url').getBundleURL('9rAa3') + "statuspage-right.447da08b.svg";